import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

if (window.__gvUpsellBound) {
  // already wired — survives drawer morphs via event delegation
} else {
  window.__gvUpsellBound = true;

  let adding = false;

  async function refreshCart() {
    const cartItemsComponent = document.querySelector('cart-items-component');
    if (cartItemsComponent?.fetchCartData) {
      await customElements.whenDefined('cart-items-component');
      return cartItemsComponent.fetchCartData();
    }
    const res = await fetch(`${Theme.routes.cart_url}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
    return res.json();
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-gv-upsell-add]') : null;
    if (!btn || adding) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    adding = true;
    const prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });
    if (sectionIds.length) {
      formData.set('sections', [...new Set(sectionIds)].join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const fetchCfg = fetchConfig('javascript', { body: formData });
      const response = await fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: 'application/json',
        },
      }).then((res) => res.json());

      if (response.status) {
        btn.dispatchEvent(
          new CartErrorEvent({
            error: response.message || 'Add to cart failed',
            code: 'INVALID',
          })
        );
        const ajaxCart = await refreshCart().catch(() => null);
        deferred.resolve({
          cart: ajaxCart
            ? CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart)
            : { totalQuantity: 0, cost: {}, lines: [] },
          detail: {
            didError: true,
            items: ajaxCart?.items || [],
            source: 'glowvelle-cart-upsell',
            itemCount: 1,
          },
        });
        return;
      }

      const ajaxCart = await refreshCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'glowvelle-cart-upsell',
          itemCount: 1,
          sections: response.sections,
          didError: false,
        },
      });

      document.querySelectorAll('[data-gv-cart-count]').forEach((el) => {
        el.textContent = String(ajaxCart.item_count);
      });
    } catch (error) {
      console.error(error);
      deferred.reject(error);
      btn.dispatchEvent(
        new CartErrorEvent({
          error: error?.message || 'Network error during add to cart',
          code: 'SERVICE_UNAVAILABLE',
        })
      );
    } finally {
      adding = false;
      btn.disabled = false;
      btn.textContent = prev || '+ Add';
    }
  });
}
